"use client";

import { CmpProvider } from "ui/src/organism/CMP/context";

export const Providers = ({ children }: any) => {
  return <CmpProvider>{children}</CmpProvider>;
};
